/**
 * InstanceField — label + value row used inside ``DetailSection`` bodies.
 *
 * Renders ``Label: value`` (label bold, value muted). Falls back to the
 * em-dash placeholder when the value is null / undefined / empty.
 */

export interface InstanceFieldProps {
  label: string;
  value: string | null | undefined;
}

export function InstanceField({ label, value }: InstanceFieldProps) {
  return (
    <div className="text-sm text-primary-gray-light-600">
      <span className="font-bold">{label}: </span>
      <span>{value && value !== "" ? value : "—"}</span>
    </div>
  );
}

export default InstanceField;
